import axiosInstance from '../api/axiosInstance';

const ENDPOINTS = {
  GET_MAHALLE_DATA: '/GetMahalleData',
  GET_MAHALLE_EXCEL_DATA: '/GetMahalleDataExcel',
}

export const getMahalleData = async (params = {}) => {
    const { offset = 0, days, date, ilce, mah, sokak } = params;
    let url = `${axiosInstance.defaults.baseURL}${ENDPOINTS.GET_MAHALLE_DATA}?offset=${offset}`;  
    if (days !== undefined && days !== '') url += `&days=${days}`;
    if (date !== undefined && date !== '') url += `&date=${date}`;
    if (ilce !== undefined && ilce !== '') url += `&ilce=${ilce}`;
    if (mah !== undefined && mah !== '') url += `&mah=${mah}`;
    if (sokak) {
      url += `&sokak=${encodeURIComponent(sokak)}`;
    }

    const response = await fetch(url, {
      headers: {
        'accept': '*/*',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    });
  
    if (!response.ok) {
      throw new Error('Personel verileri alınamadı');
    }
  
    return response.json();
}

export const getMahalleExcelData = async (params = {}) => {
    const { ilce, mah, days } = params;
    let url = `${axiosInstance.defaults.baseURL}${ENDPOINTS.GET_MAHALLE_EXCEL_DATA}?ilce=${ilce}&mah=${mah}`;
    if (days !== undefined && days !== '') url += `&days=${days}`;
    
    const response = await fetch(url, {
        headers: {
            'accept': '*/*',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
    });

    if (!response.ok) {
        throw new Error('Excel indirme işlemi başarısız oldu');
    }

    return response;
}

